import { Modal, Typography } from 'antd';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface SubmitConfirmationModalProps {
  visible: boolean;
  onSubmit: () => Promise<void>;
  onCancel: () => void;
}

const SubmitConfirmationModal = (props: SubmitConfirmationModalProps) => {
  const { t } = useTranslation('common');
  const { visible, onSubmit, onCancel } = props;
  return (
    <Modal
      title={t('submit.confirmation.modal.title')}
      visible={visible}
      onOk={onSubmit}
      onCancel={onCancel}
      okText={t('submit.confirmation.modal.okText')}
      cancelText={t('submit.confirmation.modal.cancelText')}
      centered
    >
      <StyledDiv>
        <p>{t('submit.confirmation.modal.description')}</p>
      </StyledDiv>
    </Modal>
  );
};

const StyledDiv = styled.div`

`

export default SubmitConfirmationModal;